/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Authagreementprivacypolicy3Inputs */



/**
* | output |
* | --- |
* | "Privacy Policy" |
*
* @param {Authagreementprivacypolicy3Inputs} inputs
* @param {{ locale?: "ja-JP" | "en-US" | "fr-FR" | "de-DE" | "zh-TW" | "ko-KR" }} options
* @returns {LocalizedString}
*/
const authagreementprivacypolicy3 = /** @type {((inputs?: Authagreementprivacypolicy3Inputs, options?: { locale?: "ja-JP" | "en-US" | "fr-FR" | "de-DE" | "zh-TW" | "ko-KR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Authagreementprivacypolicy3Inputs, { locale?: "ja-JP" | "en-US" | "fr-FR" | "de-DE" | "zh-TW" | "ko-KR" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en-US") return /** @type {LocalizedString} */ ("Privacy Policy")
	if (locale === "fr-FR") return /** @type {LocalizedString} */ ("Politique de confidentialité")
	if (locale === "de-DE") return /** @type {LocalizedString} */ ("Datenschutzrichtlinie")
	if (locale === "zh-TW") return /** @type {LocalizedString} */ ("隱私權政策")
	if (locale === "ko-KR") return /** @type {LocalizedString} */ ("개인정보 처리방침")
	return /** @type {LocalizedString} */ ("プライバシーポリシー")
});
export { authagreementprivacypolicy3 as "authAgreementPrivacyPolicy" }